import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GstPanInput from "../../FirmOnboarding/Components/GstPanInput";
import UserAddressStep from "./OnboardBuyerAddress/UserAddressStep";
import { buildKycFromOperational } from "../Redux/kycDetailsBuilders";

const FirmDetailsStep = ({ onPreviewChange, onRequestCancel }) => {
  const dispatch = useDispatch();
  const selectedRole = useSelector(
    (state) => state.onboardBuyerReducer.selectedRole,
  );
  const userDetails = useSelector(
    (state) => state.onboardBuyerReducer.userDetails,
  );
  const kycDetails = useSelector(
    (state) => state.onboardBuyerReducer.kycDetails,
  );
  const operationalDetails = useSelector(
    (state) => state.FirmOnboardingReducer.operational_details,
  );

  useEffect(() => {
    dispatch({
      type: "SET_SHOW_GST_INPUT",
      payload: !!selectedRole?.onboarding_config?.is_gst_required,
    });
  }, [dispatch, selectedRole]);


  useEffect(() => {
    if (operationalDetails && !kycDetails) {
      dispatch({
        type: "SET_KYC_DETAILS",
        payload: buildKycFromOperational(operationalDetails, userDetails?.name),
      });
    }
  }, [operationalDetails, kycDetails, userDetails, dispatch]);

  if (kycDetails) {
    return (
      <UserAddressStep
        onPreviewChange={onPreviewChange}
        onRequestCancel={onRequestCancel}
      />
    );
  }

  return (
    <Box sx={{ width: "616px", maxWidth: "100%" }}>
      <GstPanInput justify="flex-start" onSuccess={() => {}} />
    </Box>
  );
};

export default FirmDetailsStep;
